module.exports = __webpack_public_path__ + "static/build-shifts-fast-8bc2be157f15bfd2379baa639586e31f.png";